export const SCROLL_POSITION = 'scrollPosition';
export const LOCATION_KEY = 'locationKey';
export const PREVIOUS_LOCATION = 'previousLocation';



// WEBPACK FOOTER //
// ./src/constants/storageKeys.js